export default "__VITE_ASSET__2c52af54__"